
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tcs-asia-pacific",
      function () {
        return require("private-next-pages/tcs-asia-pacific.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tcs-asia-pacific"])
      });
    }
  